import { callGet, callPost, callDelete } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const getDate = async (token) => {
  return await callGet(REQ.OPENING_BALENCE_GL.GET_DATE, token);
};

export const saveData = async (data, token) => {
  return await callPost(REQ.OPENING_BALENCE_GL.SAVE_DATA, data, token);
};

export const getData = async (token) => {
  return await callGet(`${REQ.OPENING_BALENCE_GL.GET_DATA}`, token);
};

export const updateJV = async (data, token) => {
  return await callPost(
    `${REQ.OPENING_BALENCE_GL.UPDATE_JOURNAL}`,
    data,
    token
  );
};

export const deleteSingleJournal = async (id, token) => {
  return await callDelete(
    `${REQ.OPENING_BALENCE_GL.DELETE_SINGLE_TRANSACTION}/${id}`,
    {},
    token
  );
};

export const deleteVoucher = async (token) => {
  return await callDelete(`${REQ.OPENING_BALENCE_GL.DELETE_ALL}`, {}, token);
};

export const deleteZeroEntry = async (token) => {
  return await callDelete(
    `${REQ.OPENING_BALENCE_GL.DELETE_ZERO_ENRTY}`,
    {},
    token
  );
};
